import { PostCheckStateTypes, PostCheckActionTypes } from "./PostCheck.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: PostCheckStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const PostCheckReducer = (
  state: PostCheckStateTypes = INITIAL_STATE,
  action: any
): PostCheckStateTypes => {
  switch (action.type) {
    case PostCheckActionTypes.FETCH_ALL_POST_CHECK:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case PostCheckActionTypes.FETCH_ALL_POST_CHECK_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case PostCheckActionTypes.FETCH_ALL_POST_CHECK_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case PostCheckActionTypes.FETCH_ALL_POST_CHECK_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case PostCheckActionTypes.FETCH_ONE_POST_CHECK:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case PostCheckActionTypes.FETCH_ONE_POST_CHECK_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case PostCheckActionTypes.FETCH_ONE_POST_CHECK_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case PostCheckActionTypes.FETCH_ONE_POST_CHECK_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default PostCheckReducer;
